/* eslint-disable jsx-a11y/anchor-is-valid */
import React from "react";
import { useHistory } from "react-router-dom";

export default (props) => {
  const history = useHistory();
  return (
    <section className="content-header">
      <div className="container-fluid">
        <div className="row mb-2">
          <div className="col-sm-6">
            <h1 className="m-0 text-dark">
              <i className={`hidden-xs fa fa-${props.icon}`}></i>
              {props.title}
            </h1>
          </div>
          <div className="col-sm-6">
            <ol className="breadcrumb float-sm-right">
              <li className="breadcrumb-item">
                <a
                  style={{ cursor: "pointer", color: "blue" }}
                  onClick={() => history.push(`${props.urlPrevious}`)}
                >
                  {props.previousTitle}
                </a>
              </li>
              <li className="breadcrumb-item active">{props.smallTitle}</li>
            </ol>
          </div>
        </div>
      </div>
    </section>
  );
};
